// removed by extract-text-webpack-plugin
module.exports = {"name":"_3Npjh","date_of_birth":"eEfGw","actions":"_15rYR","header":"_3o6Ln"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PersonalInfo/columns.scss
// module id = 2580
// module chunks = 0